<template>
  <div :class="classes">
    <question-back-button v-if="showBackButton" @click="$emit('prev')" />
    <div v-else />
    <div class="trbo-a-page-footer__right">
      <skip-button
        v-if="showSkipButton"
        @click="$emit('skip')"
      />
      <component
        :is="rightButtonComponent"
        v-if="Boolean(rightButtonComponent)"
        @click="event => $emit(event)"
      />
    </div>
    <div class="trbo-a-page-footer__powered-by">
      <powered-by
        v-if="showPoweredBy"
        :chatchamp-link-clickable="chatchampLinkClickable"
        :customer-id="customerId"
      />
    </div>
  </div>
</template>

<script>
// @flow

import { mapGetters, mapState } from 'vuex'

import { isMobile } from '../../../../common/device'

import PoweredBy from '../../PoweredBy/PoweredBy.vue'
import QuestionBackButton from '../QuestionBackButton/QuestionBackButton.vue'
import NextButton from '../NextButton/NextButton.vue'
import SkipButton from '../SkipButton/SkipButton.vue'
import LoadMoreProductsButton from '../LoadMoreProductsButton/LoadMoreProductsButton.vue'

export default {
  components: {
    QuestionBackButton,
    NextButton,
    SkipButton,
    LoadMoreProductsButton,
    PoweredBy
  },
  computed: {
    ...mapGetters(['moreProductsAvailable', 'isCurrentProductsPage', 'isCurrentPageText', 'isCurrentPageVideo', 'isCurrentPageOptional', 'isAnyOptionSelectedForCurrentPage', 'isLastPage', 'isCurrentPageRange', 'isCurrentPageInput', 'chatchampLinkClickable', 'isCurrentPageImage']),
    ...mapState(['wizard', 'wizardPageIndex', 'isSavingWizardPageAnswer', 'customerId', 'isEmbedded']),
    classes (): Object {
      return {
        'trbo-a-page-footer': true,
        'trbo-a-page-footer--is-embedded': this.isEmbedded
      }
    },
    rightButtonComponent (): ?string {
      if (this.isSavingWizardPageAnswer) return null
      if (this.isCurrentProductsPage && this.moreProductsAvailable > 0) return 'LoadMoreProductsButton'
      if (this.isLastPage) return null
      if (this.showNextButton) return 'NextButton'

      return null
    },
    showBackButton (): boolean {
      return !this.wizard.skipLandingPage || this.wizardPageIndex > 0
    },
    showNextButton (): boolean {
      return (!this.isCurrentProductsPage && this.isAnyOptionSelectedForCurrentPage && !this.isCurrentPageInput) || this.isCurrentPageText || this.isCurrentPageVideo || this.isCurrentPageRange || this.isCurrentPageImage
    },
    showSkipButton (): boolean {
      return !this.isLastPage && !this.isCurrentProductsPage && this.isCurrentPageOptional && (!this.showNextButton || this.isCurrentPageRange)
    },
    showPoweredBy (): boolean {
      return (!this.showSkipButton && this.rightButtonComponent === null) || !isMobile()
    }
  }
}
</script>

<style scoped src="./page-footer.scss" />
